<ng-container *transloco="let t">
<div id="demographics-main">
  @if (showOptionToNotProvideDemographicsInfo) {
    <div class="row rounded border mb-6 px-6 py-4">
      <label class="form-check form-check-inline form-check-solid me-5">
        <input class="form-check-input" name="dontWantToProvideAnyOfTheInfo" type="checkbox"
          [(ngModel)]="dontWantToProvideAnyOfTheInfo" (ngModelChange)="dontWantToProvideAnyInfoCheckChanged()" />
        <span class="fw-bold ps-2 fs-6">{{ t('wizard.demographics.doNotWantToProvide') }}</span>
      </label>
    </div>
  }

  <div class="row rounded border mb-6 px-6 py-4"
    [ngClass]="{'border-danger': !ethnicityHasValidSelection}">
    <label class="col-lg-12 col-form-label required fw-bold fs-4">{{ t('wizard.demographics.statedEthnicity') }}</label>
    <div class="col-lg-12 fv-row mb-6">
      @if (ethnicityOptions.length > 0) {
        <multi-checkbox [name]="borrower.borrowerId + '_ethnicity'"
          name="borrower.borrowerId + '_ethnicity'" [options]="ethnicityOptions" [(ngModel)]="ethnicities"
          (change)="etnicityChanged()">
        </multi-checkbox>
      }
    </div>
    @if (ethnicityOptions.length > 0 && isHispanicOrLatinoSelected()) {
      <div class="rounded border mt-3 px-6 py-4">
        <div class="col-lg-12 fv-row mb-4">
          @if (hispanicOriginOptions.length > 0) {
            <multi-checkbox [name]="borrower.borrowerId + '_ethnicityOrigin'"
              [options]="hispanicOriginOptions" [(ngModel)]="ethnicityOrigins" (change)="ethnicityOriginChanged()">
            </multi-checkbox>
          }
        </div>
        @if (isOtherSelectedForHispanicOrLatinoEthnicity()) {
          <div class="col-lg-6 fv-row mb-6">
            <div class="position-relative">
              <input type="text" class="form-control form-control-solid"
                [(ngModel)]="borrower.governmentMonitors.ethnicityOriginOtherDescription" [placeholder]="t('wizard.demographics.enterOriginHere')"
                name="ethnicityOriginOtherDescription" />
            </div>
          </div>
        }
      </div>
    }
  </div>

  <div class="row rounded border mb-6 px-6 py-4"
    [ngClass]="{'border-danger': !sexHasValidSelection}">
    <label class="col-lg-12 col-form-label required fw-bold fs-4">{{ t('wizard.demographics.statedSex') }}</label>
    <div class="col-lg-12 fv-row mb-6">
      @if (sexOptions.length > 0) {
        <multi-checkbox [name]="borrower.borrowerId + '_sex'" [options]="sexOptions"
          [(ngModel)]="sexes" (change)="onSexInformationChanged()">
        </multi-checkbox>
      }
    </div>
  </div>

  <div class="row rounded border mb-6 px-6 py-4"
    [ngClass]="{'border-danger': !raceHasValidSelection}">
    <label class="col-lg-12 col-form-label required fw-bold fs-4">{{ t('wizard.demographics.statedRace') }}</label>
    <div class="col-lg-12 fv-row mb-6">
      <div class="mt-3">
        @for (race of raceOptions; track race.value) {

          <div class="form-check form-check-inline form-check-solid me-5 mb-5">
            <input id="{{borrower.borrowerId}}_race-{{race.name}}" class="form-check-input" [value]="race.value"
              type="checkbox" name="{{borrower.borrowerId}}_race-{{race.name}}"
              (change)="raceChanged($event, race.value)" [checked]="races.includes(race.value)">
            <label for="{{borrower.borrowerId}}_race-{{race.name}}" class="fw-bold ps-2 fs-6">
              {{race.name}}
            </label>
          </div>

          @if (race.value == nativeAmericanRace && isNativeAmericanSelected()) {
            <div class="col-lg-6 fv-row mb-6">
              <div class="position-relative">
                <input type="text" class="form-control form-control-solid"
                  [(ngModel)]="borrower.governmentMonitors.nativeAmericanTribeName"
                  [title]="t('wizard.demographics.printTribeName')"
                  [placeholder]="t('wizard.demographics.tribeName')" name="'tribeName_' + borrower.borrowerId" />
              </div>
            </div>
          }

          @if (race.value == asianRace && isAsianSelected()) {
            <div class="rounded border px-6 py-4 mb-5">
              <div class="col-lg-12 fv-row mb-4">
                @if (asianRaceDesignationOptions.length > 0) {
                  <multi-checkbox [name]="borrower.borrowerId + '_asianRaceDesignation'"
                    [options]="asianRaceDesignationOptions" [(ngModel)]="raceDesignations"
                    (change)="raceDesignationChanged()">
                  </multi-checkbox>
                }
              </div>
              @if (isOtherSelectedForAsianRace()) {
                <div class="col-lg-6 fv-row mt-4 mb-5">
                  <div class="position-relative">
                    <input type="text" class="form-control form-control-solid"
                      [(ngModel)]="borrower.governmentMonitors.otherAsianRace" [placeholder]="t('wizard.demographics.enterRace')"
                      name="'otherAsian_' + borrower.borrowerId" />
                  </div>
                </div>
              }
            </div>
          }

          @if (race.value == pacificIslanderRace && isPacificIslanderSelected()) {
            <div class="rounded border px-6 py-4 mb-5">
              <div class="col-lg-12 fv-row mb-4">
                @if (pacificIslanderRaceDesignationOptions.length > 0) {
                  <multi-checkbox [name]="borrower.borrowerId + '_pacificIslanderRaceDesignation'"
                    [options]="pacificIslanderRaceDesignationOptions" [(ngModel)]="raceDesignations"
                    (change)="raceDesignationChanged()">
                  </multi-checkbox>
                }
              </div>
              @if (isOtherSelectedForPacificIslanderRace()) {
                <div class="col-lg-6 fv-row mb-3 mt-4 mb-5">
                  <div class="position-relative">
                    <input type="text" class="form-control form-control-solid"
                      [(ngModel)]="borrower.governmentMonitors.otherPacificIslanderRace" [placeholder]="t('wizard.demographics.enterRace')"
                      name="'otherPacificislander_' + borrower.borrowerId" />
                  </div>
                </div>
              }
            </div>
          }
        }
      </div>
    </div>
  </div>
</div>
</ng-container>
